import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getData } from '../../Actions/DropDown/getData';

class Range extends React.PureComponent {
  componentWillMount() {
    this.props.getData({ key: this.props.dataKey });
  }

  update = (e) => {
    this.props.onChange(e.target.value);
  }

  render() {
    const { options, setRef } = this.props;

    return (
      <div className="input-range">
        { options.length === 0 ?
          <span className="loading-text">Loading...</span> :
          <div className="range-text-group">
            {this.props.options.map(o => (
              <span key={o.id + this.props.name + o.id} htmlFor={this.props.name + (this.props.editable ? o.value : o.key)} className="range-text">{o.value}</span>
            ))}
          </div>
        }
        <div className="range-container">
          <input type="range" name={this.props.name} min="0" max="7" step="1" ref={setRef} onChange={this.update} />
        </div>
      </div>
    );
  }
}

Range.propTypes = {
  dataKey: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const data = {
    ...ownProps,
    options: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].options : [],
    editable: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].editable : 0,
  };

  data.options.sort((a, b) => (a.value > b.value ? 1 : -1));
  return data;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getData: (p) => { dispatch(getData(p)); },
});

const RangeLink = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Range);

export default RangeLink;




// WEBPACK FOOTER //
// ./src/Components/Inputs/Range.jsx